import React, { useEffect, useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import formatDate from "../../common/Formatdate";
import Task from "../../assets/task.png";
import Completed from "../../assets/checked.png";
import Pending from "../../assets/work-in-progress.png";
import Urgent from "../../assets/alarm.png";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  IconButton,
  useMediaQuery,
  Typography,
  TablePagination,
  TextField,
  Autocomplete,
  Modal,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import Bookingdetailstab from "./Bookingdetailstab";
import commonapihandler from "../../common/commonapihandler";
import { getHubName, getSystemUserList } from "../../api/api";
import formatDateAndTime from "../../common/formatDateAndTime";
import { BlinkBlur } from "react-loading-indicators";
import toast from "react-hot-toast";
import moment from "moment";
import { camelToNormal } from "../../common/caseconversion";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Fieldscommonmodal from "../../common/Fieldscommonmodal";
import Uploadmultplefile from "../../common/Uploadmultplefile";
import fileupload from "../../common/fileupload";
import Textfields from "../../common/Textfields";
import Commongrid from "../../common/Commongrid";
import getactions from "../../common/getactions";
import VehicleProfile from "./VehicleProfile";
import CircularProgress from "@mui/material/CircularProgress";

function createData(
  id,
  vehicleid,
  name,
  vehicleType,
  registrationno,
  isAssociateVehicle,
  city,
  issubscription,
  groupname,
  onboardingdate,
  registrationdate,
  status,
  currentodometer,
  createdon,
  action,
  block,
) {
  return {
    id,
    vehicleid,
    name,
    vehicleType,
    registrationno,
    isAssociateVehicle,
    city,
    issubscription,
    groupname,
    onboardingdate,
    registrationdate,
    status,
    currentodometer,
    createdon,
    action,
    block,
  };
}

const Vehicledashboard = ({ setActiveItem }) => {
  const querydisplay = new URLSearchParams(window.location.search).get(
    "display",
  );
  const vehicleTypeList = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleType;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const isMobile = useMediaQuery("(max-width:768px)");
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);

  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });
  const [dateFitlerBy, setDateFilterBy] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [openTab, setOpenTab] = useState(false);
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState("");
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState("");
  const [allBookings, setAllBookings] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [vehicleListings, setVehicleListings] = useState([]);
  const [vehicleId, setVehicleId] = useState(null);
  const [selectedSearchButton, setSelectedSearchButton] = useState("");
  const [searchValues, setSearchValues] = useState(null);
  const [bookingstatus, setBookingStatus] = useState(null);
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [form, setForm] = useState({
    currentOdometer: null,
  });
  const [error, setError] = useState("");
  const catalogRoles = JSON.parse(localStorage.getItem("catalogValues"))?.role
    ?.inverted?.franchiseAdmin;
  const catalogRActions = JSON.parse(localStorage.getItem("catalogValues"))
    ?.action?.inverted?.viewMyCityBookings;
  const vehicleStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleStatus;
  const blockRequestTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.blockRequestTypes;
  const vehicleBlockType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBlockType;
  const [vehicleData, setVehicleData] = useState(null);
  const [vehicleIssuesData, setVehicleIssuesData] = useState(null);
  const [editType, setEditType] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [uploadedImages, setUploadedImages] = useState(null);
  const [systemUserList, setSystemUserList] = useState([]);
  const [vehicleLoading, setVehicleLoading] = useState(false);
  const [affectedBookings, setAffectedBookings] = useState([]);
  const [blockedVehciles, setBlockedVehicles] = useState([]);
  const [vehicleType, setVehicleType] = useState(null);

  let vehicleTypeData = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleType;
  delete vehicleTypeData?.inverted;

  const getaffectedbookings = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookings/getbookingbydates?startDate=${
          form?.startdate + "T" + form?.starttime
        }&endDate=${form?.enddate + "T" + form?.endtime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const filtered = data?.dataValues?.filter(
          (item) => String(item.vehicleId) === String(selectedRow?.id),
        );
        setAffectedBookings(filtered);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Affected Bookings:", error);
    }
  };

  const getaffectedBlockings = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/blockedvehicles/blocklistbyvehicle?vehicleId=${vehicleData?.id}&startDate=${
          form?.startdate + "T" + form?.starttime
        }&endDate=${form?.enddate + "T" + form?.endtime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setBlockedVehicles(data?.dataValues);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Affected Bookings:", error);
    }
  };

  useEffect(() => {
    if (form?.startdate && form?.starttime && form?.enddate && form?.endtime) {
      getaffectedbookings();
      getaffectedBlockings();
    }
  }, [form?.startdate, form?.starttime, form?.enddate, form?.endtime]);

  const getStatusLabel = (key) => {
    try {
      const val = vehicleStatus?.[key];
      if (val == null) return key || "-";
      if (typeof val === "string") return val;
      if (typeof val === "object") return val?.label || val?.text || key;
      return String(val);
    } catch (e) {
      return key || "-";
    }
  };
  const [vehicleFilterListings, setVehicleFilterListings] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const getVehicleTypeLabel = (type) => {
    if (!vehicleTypeList) return "-";

    const match = Object.entries(vehicleTypeList)
      .filter(([key]) => key !== "inverted")
      .find(([key]) => Number(key) === Number(type));

    return match ? match[1] : "-";
  };

  const vehicleDetailsFields = [
    {
      label: "Current Odometer",
      value: "currentOdometer",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Status",
      value: "status",
      type: "dropdown",
      disabled: false,
      subCategory: Object.entries(vehicleStatus).map(([key, value]) => ({
        value: value,
        item: key,
      })),
    },
    {
      label: "Car Image ( Single Image )",
      value: "carimage",
      type: "file",
      disabled: false,
      subCategory: null,
    },
  ];

  const vehicleDetailsBlockFields = [
    {
      label: "Start Date",
      value: "startdate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Start Time",
      value: "starttime",
      type: "time",
      disabled: false,
      subCategory: null,
    },
    {
      label: "End Date",
      value: "enddate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "End Time",
      value: "endtime",
      type: "time",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Vehicle",
      value: "vehicle",
      type: "text",
      disabled: true,
      subCategory: null,
    },
    {
      label: "Current Odometer",
      value: "currentOdometer",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Requested By",
      value: "requestedby",
      type: "dropdown",
      disabled: false,
      subCategory:
        blockRequestTypes &&
        Object.entries(blockRequestTypes).map(([key, value]) => ({
          value: value,
          item: key,
        })),
    },
    {
      label: "Block Type",
      value: "blocktype",
      type: "dropdown",
      disabled: false,
      subCategory:
        vehicleBlockType &&
        Object.entries(vehicleBlockType).map(([key, value]) => ({
          value: value,
          item: key,
        })),
    },
    {
      label: "Vehicle Issues",
      value: "vehicleissues",
      type: "dropdown",
      disabled: false,
      subCategory: Array.isArray(vehicleIssuesData)
        ? vehicleIssuesData.map((item) => {
            return {
              value: item?.code,
              item: item?.id,
            };
          })
        : [],
    },
    {
      label: "Booking Id",
      value: "bookingid",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Comment",
      value: "comment",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Odometer Image",
      value: "odometerimage",
      type: "file",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Other Attachments",
      value: "otherattachments",
      type: "file",
      disabled: false,
      subCategory: null,
    },
  ];

  useEffect(() => {
    if (querydisplay) {
      setOpenTab(true);
    }
  }, [querydisplay]);

  const getVechileListings = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicles?limit=500&offset=0&hubId=${id}`,
        {
          method: "GET",
        },
      );
      const data = await response.json();
      setVehicleLoading(false);
      if (data?.statusCode === "0100") {
        setVehicleFilterListings(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const getVehicleData = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/vehicles/${id}`, {
        method: "GET",
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleData(data?.entityValue);
        if (editType !== "edit") {
          await getVehicleIssuesData(id);
        }
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const getVehicleIssuesData = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleissues?limit=100&offset=0&status=523&vehicleId=${id}`,
        {
          method: "GET",
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleIssuesData(data?.entities?.rows);
        if (editType !== "edit") {
        }
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const getSystemUserAPI = async (id) => {
    const apiDetails = await getSystemUserList(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response?.statusCode === "0100") {
      setSystemUserList(response?.entities?.rows);
    }
  };

  useEffect(() => {
    setForm({
      currentOdometer: vehicleData?.currentOdometer || null,
      status: vehicleData?.status || null,
      vehicle: vehicleData?.name || null,
      carimage: vehicleData?.imageUrl || null,
    });
    setUploadedImages([vehicleData?.imageUrl]);
  }, [vehicleData]);

  const handleInputValueChanges = (label, event) => {
    const value = event.target.value;
    const key = label?.value;

    if (key) {
      setSelectedVehicle(value);
    }
  };

  useEffect(() => {
    if (hub) {
      getVechileListings(hub);
    }
  }, [hub]);

  const handleModalClose = () => {
    setSelectedRow(null);
    setForm({
      currentOdometer: null,
    });
    setActiveTab(0);
    setOpenModal(false);
    setBlockedVehicles([]);
    setError("");
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 100,
      align: "start",
      sortable: false,
    },
    // {
    //   field: "vehicleid",
    //   headerName: "Vehicle Id",
    //   minWidth: 170,
    //   align: "start",
    //   sortable: false,
    // },
    {
      field: "name",
      headerName: "Vehicle Name",
      minWidth: 200,
      align: "start",
      sortable: false,
    },
    {
      field: "vehicleType",
      headerName: "Vehicle Type",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "registrationno",
      headerName: "Registration No",
      minWidth: 150,
      align: "start",
    },
    {
      field: "isAssociateVehicle",
      headerName: "Is Associate Vehicle",
      minWidth: 150,
      align: "start",
      renderCell: (params) =>
        params.value === "True" ? (
          <Box
            sx={{
              // backgroundColor: "#216e09",
              color: "#216e09",
              fontWeight: 700,
              px: 1,
              py: 0.5,
              borderRadius: 1,
              textAlign: "center",
              width: "100%",
            }}
          >
            {params.value || "-"}
          </Box>
        ) : (
          <Box
            sx={{
              // backgroundColor: "#802016",
              color: "#802016",
              fontWeight: 700,
              px: 1,
              py: 0.5,
              borderRadius: 1,
              textAlign: "center",
              width: "100%",
            }}
          >
            {params.value || "-"}
          </Box>
        ),
    },
    { field: "city", headerName: "City", minWidth: 100, align: "start" },
    {
      field: "issubscription",
      headerName: "Subscription",
      minWidth: 100,
      align: "start",
      renderCell: (params) =>
        params.value === "True" ? (
          <Box
            sx={{
              color: "#31e305",
              fontWeight: 700,
              px: 1,
              py: 0.5,
              borderRadius: 1,
              textAlign: "center",
              width: "100%",
            }}
          >
            {params.value || "-"}
          </Box>
        ) : (
          <Box
            sx={{
              color: "#0728e3",
              fontWeight: 700,
              px: 1,
              py: 0.5,
              borderRadius: 1,
              textAlign: "center",
              width: "100%",
            }}
          >
            {params.value || "-"}
          </Box>
        ),
    },
    {
      field: "groupname",
      headerName: "Group Name",
      minWidth: 250,
      align: "start",
      sortable: false,
    },
    {
      field: "onboardingdate",
      headerName: "On Boarding Date",
      minWidth: 200,
      align: "start",
    },
    {
      field: "registrationdate",
      headerName: "Registration Date",
      minWidth: 200,
      align: "start",
    },
    { field: "status", headerName: "Status", minWidth: 200, align: "start" },
    {
      field: "currentodometer",
      headerName: "Current Odometer",
      minWidth: 150,
      align: "start",
    },
    {
      field: "createdon",
      headerName: "Created On",
      minWidth: 200,
      align: "start",
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 90,
      align: "start",
      sortable: false,
      renderCell: (params) => {
        const row = params.row;

        return (
          actionsToAccess?.includes("Update Vehicle") && (
            <Button
              sx={{
                bgcolor: "#4556f1ff",
                fontWeight: 500,
                px: 1,
                color: "white",
                borderRadius: 1,
                width: "100%",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation(); // ✅ VERY IMPORTANT
                setActiveTab(1);
                setSelectedRow(row);
                setOpenModal(true);
                setEditType("edit");
              }}
            >
              Edit
            </Button>
          )
        );
      },
    },
    {
      field: "block",
      headerName: "Block",
      minWidth: 150,
      align: "start",
      sortable: false,
      renderCell: (params) => {
        const row = params.row; // 👈 FULL ROW DATA

        return (
          actionsToAccess?.includes("Block Vehicle") && (
            <Button
              sx={{
                bgcolor: "#e91f1fff",
                fontWeight: 500,
                px: 1,
                color: "white",
                // py: 0.5,
                borderRadius: 1,
                textAlign: "center",
                width: "100%",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation(); // ✅ stop row click
                setActiveTab(2);
                setSelectedRow(row);
                setOpenModal(true);
                setEditType("block");
              }}
            >
              Block Vehicle
            </Button>
          )
        );
      },
    },
  ];

  const rows =
    (allBookings &&
      allBookings?.map((item) =>
        createData(
          item?.id,
          item?.vehicleUuid,
          camelToNormal(item?.name),
          getVehicleTypeLabel(item?.vehicleType),
          item?.licensePlate || "/",
          item?.isAssociateVehicle ? "True" : "False",
          cities[item?.cityId] || "N/A",
          item?.isSubscriptionEnabled ? "True" : "False",
          item?.vehicleGroupText,
          formatDate(item?.onBoardingDate) || "N/A",
          formatDate(item?.registrationDate) || "N/A",
          getStatusLabel(item?.status) || "N/A",
          item?.currentOdometer || "N/A",
          formatDate(item?.createdAt) || "N/A",
          "View",
          "Block Vehicle",
        ),
      )) ||
    [];

  useEffect(() => {
    if (querydisplay) {
      setOpenTab(true);
    }
  }, [querydisplay]);

  function formatDateForApi(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formattedStartDate = formatDateForApi(selectionRange?.startDate);
  const formattedEndDate = formatDateForApi(selectionRange?.endDate);

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    getCityNames();
    getAllVehicles();
    getAllHubsList();
    getSystemUserAPI(1);
  }, []);

  const getAllHubsList = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubs?limit=1000`);
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setGetAllHubsListData(data?.entities?.rows);
      }
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const handleCityChange = (event) => {
    setPage(0);
    const value = event.target.value;
    setCity(value);
    getHubNames(value);
  };

  const handleVehicleTypeChange = (event) => {
    setPage(0);
    const value = event.target.value;
    setVehicleType(value);
  };

  const getHubNames = async (value) => {
    const apiDetails = await getHubName(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
  };

  const handleHubChange = (event) => {
    setPage(0);
    setHub(event.target.value);
  };

  const getAllVehicles = async (
    customPage = page,
    customRowsPerPage = rowsPerPage,
  ) => {
    setLoading(true);
    const offset = (customPage ?? 0) * (customRowsPerPage ?? rowsPerPage);
    let query = "";

    if (
      profile?.roles.includes(Number(catalogRoles)) ||
      profile?.actions.includes(Number(catalogRActions))
    ) {
      query += `&cityId=${profile?.cityId}`;
    } else if (city) {
      query += `&cityId=${city}`;
    }

    if (vehicleType) {
      query += `&vehicleType=${vehicleType}`;
    }

    if (selectedVehicle) {
      let split = selectedVehicle?.licensePlate?.split(" - ");
      let licensePlate = split ? split[0] : selectedVehicle?.licensePlate;
      query += `&licensePlate=${licensePlate}`;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/vehicles?limit=${customRowsPerPage}&offset=${offset}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setAllBookings(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      } else {
        setLoading(false);
        toast.error(data?.msg || data?.message);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const UpdateVehicleDetails = async () => {
    if (editType === "edit") {
      if (!form?.carimage) {
        return toast?.error("Upload Car Image", {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
      }
      try {
        const response = await fetch(`${apiUrl}/api/vehicles`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            currentOdometer: Number(form?.currentOdometer),
            id: selectedRow?.id,
            status: form?.status,
            imageUrl: form?.carimage[0]?.Location || form?.carimage,
          }),
        });
        const data = await response.json();
        if (data?.statusCode === "0100") {
          setForm({
            currentOdometer: null,
          });
          setOpenModal(false);
          toast.success("Vehicle Changes Updated successfully.", {
            position: "bottom-center",
            style: {
              background: "blue", // override background
              color: "white",
              fontWeight: "medium",
              marginBottom: "50px",
            },
          });
          setActiveTab(0);
          getAllVehicles();
        } else {
          toast.error(data?.msg);
        }
        return data;
      } catch (error) {
        return console.error("Error fetching POST vehicle details:", error);
      }
    } else if (editType === "block") {
      if (!form?.startdate && !form?.starttime) {
        return toast?.error("Start date and time is not available", {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
      }
      if (!form?.enddate && !form?.endtime) {
        return toast?.error("End date and time is not available", {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
      }
      if (!form?.requestedby) {
        return toast?.error("Requested By is not available", {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
      }
      if (!form?.blocktype) {
        return toast?.error("Block type is not available", {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
      }
      if (!form?.odometerimage) {
        return toast?.error("Odometer image is not available", {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
      }
      if (!form?.currentOdometer) {
        return toast?.error("Odometer is not available", {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
      }
      try {
        const response = await fetch(`${apiUrl}/api/blockedvehicles`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            name: form?.vehicle,
            licensePlate: vehicleData?.licensePlate,
            initialOdometer: form?.currentOdometer,
            comment: form?.comment,
            vehicleId: vehicleData?.id,
            blockType: form?.blocktype,
            startDate: form?.startdate
              ? `${form?.startdate}T${form?.starttime}`
              : null,
            endDate: form?.enddate ? `${form?.enddate}T${form?.endtime}` : null,
            blockedBy: profile?.email,
            bookingCode: form?.bookingid,
            odometerImages: form?.odometerimage,
            attachments: JSON.stringify(form?.otherattachments),
            blockRequest: form?.requestedby,
            issueId: form?.vehicleissues || null,
          }),
        });
        const data = await response.json();
        if (data?.statusCode === "0100") {
          setForm({
            currentOdometer: null,
          });
          setOpenModal(false);
          toast.success("Vehicle Blocked successfully.", {
            position: "bottom-center",
            style: {
              background: "blue", // override background
              color: "white",
              fontWeight: "medium",
              marginBottom: "50px",
            },
          });
          setActiveTab(0);
          getAllVehicles();
        } else {
          toast.error(data?.msg);
        }
        return data;
      } catch (error) {
        return console.error("Error fetching POST vehicle details:", error);
      }
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);

    getAllVehicles(0, newRowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    getAllVehicles(newPage, rowsPerPage);
  };

  const handleEditClick = (row) => {
    setActiveTab(1);
    setSelectedRow(row);
    setOpenModal(true);
    setEditType("edit");
  };

  const handleBlockVehicle = (row) => {
    setActiveTab(2);
    setSelectedRow(row);
    setOpenModal(true);
    setEditType("block");
  };

  useEffect(() => {
    if (selectedRow?.id) {
      getVehicleData(selectedRow?.id);
    }
  }, [selectedRow]);

  const handleChange = async (field, value) => {
    try {
      if (field === "odometerimage" || field === "otherattachments") {
        const res = await Uploadmultplefile(value, "vehicles", "vehicle");
        const filterImages = res?.uploaded?.map((img) => img?.url);
        setUploadedImages((prev) => {
          if (!prev || prev.length === 0) {
            return filterImages; // first upload
          }
          return [...prev, ...filterImages]; // append
        });
        setForm((prev) => ({ ...prev, [field]: res?.uploaded || "" }));
      } else if (field === "carimage") {
        const res = await fileupload(value[0], "vehicles", "vehicle");
        setUploadedImages([res]);
        setForm((prev) => ({ ...prev, [field]: [res] || "" }));
      } else {
        setForm((prev) => ({ ...prev, [field]: value }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleReset = () => {
    setPaginationModel({ page: 0, pageSize: 20 });
    setCity("");
    setHub("");
    setVehicleType(null);
    setSelectedVehicle(null);
    setVehicleFilterListings([]);
    setPage(0);
    setDateFilterBy(null);
    setBookingStatus(null);
    getAllVehicles();
  };

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setOpenTab(true);
  };

  return (
    <>
      {openTab ? (
        <>
          <VehicleProfile
            systemUserList={systemUserList}
            setOpenTab={setOpenTab}
            selectedRow={selectedRow}
          />
        </>
      ) : (
        <>
          {" "}
          {activeTab === 0 ? (
            <>
              <div className="my-4 text-xl md:text-2xl px-2 font-bold flex justify-between">
                <h1>Vehicles List</h1>
                <button
                  onClick={() => {
                    setPaginationModel({ page: 0, pageSize: 20 });
                    getAllVehicles();
                  }}
                  class="p-5 rounded-full backdrop-blur-lg border border-green-500/20 bg-gradient-to-tr from-white/60 to-white/40 shadow-lg hover:shadow-2xl hover:shadow-green-500/30 hover:scale-110 hover:rotate-2 active:scale-95 active:rotate-0 transition-all duration-300 ease-out cursor-pointer hover:border-green-500/50 hover:bg-gradient-to-tr hover:from-green-500/10 hover:to-white/40 group relative overflow-hidden"
                >
                  <div class="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out"></div>
                  <div class="relative z-10">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="100"
                      height="100"
                      viewBox="0 0 30 30"
                      className="w-4 h-4"
                    >
                      <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
                    </svg>
                  </div>
                </button>
              </div>
              <Box p={isMobile ? 2 : 1}>
                <Box
                  display="flex"
                  flexDirection="column"
                  p={2}
                  borderRadius={2}
                  boxShadow={3}
                  mb={4}
                  sx={{ backgroundColor: "white" }}
                >
                  {/* Top Header Row */}
                  <Box
                    display="flex"
                    flexDirection={{ xs: "column", md: "row" }}
                    justifyContent="space-between"
                    alignItems={{ xs: "flex-start", md: "center" }}
                    mb={3}
                    gap={2}
                  ></Box>

                  <Box
                    display="grid"
                    gridTemplateColumns={{
                      xs: "1fr",
                      sm: "repeat(2, 1fr)",
                      lg: "repeat(5, 1fr)",
                    }}
                    gap={2}
                    mb={3}
                  >
                    <h1 className="mt-2">Filter By :</h1>

                    <FormControl fullWidth size="small">
                          <InputLabel id="vehicle-type-label">Vehicle Type</InputLabel>
                          <Select
                            labelId="vehicle-type-label"
                            id="vehicle-type"
                            value={vehicleType}
                            onChange={handleVehicleTypeChange}
                          >
                            {vehicleTypeData &&
                              Object.entries(vehicleTypeData).map(([key, value]) => (
                                <MenuItem key={key} value={key}>
                                  {value}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>

                    {profile?.roles.includes(Number(catalogRoles)) ||
                      (profile?.actions.includes(Number(catalogRActions)) ? (
                        <></>
                      ) : (
                        <FormControl fullWidth size="small">
                          <InputLabel id="city-select-label">City</InputLabel>
                          <Select
                            labelId="city-select-label"
                            id="city-select"
                            value={city}
                            onChange={handleCityChange}
                          >
                            {cities &&
                              Object.entries(cities).map(([key, value]) => (
                                <MenuItem key={key} value={key}>
                                  {value}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      ))}

                    {profile?.actions.includes(Number(catalogRActions)) ||
                      (profile?.actions.includes(Number(catalogRActions)) ? (
                        <></>
                      ) : (
                        <FormControl fullWidth size="small">
                          <InputLabel id="hub-select-label">Hub</InputLabel>
                          <Select
                            labelId="hub-select-label"
                            id="hub-select"
                            value={hub}
                            onChange={handleHubChange}
                          >
                            {
                              // hubs?.length ? (
                              getAllHubsListData &&
                                getAllHubsListData.map((item, index) => (
                                  <MenuItem key={index} value={item?.id}>
                                    {item?.hubName}
                                  </MenuItem>
                                ))
                              // ) : (
                              //   <MenuItem value="">
                              //     <em>Select City First</em>
                              //   </MenuItem>
                              // )
                            }
                          </Select>
                        </FormControl>
                      ))}

                    <Autocomplete
                      fullWidth
                      freeSolo
                      options={vehicleFilterListings || []}
                      getOptionLabel={(option) => {
                        if (typeof option === "string") return option;

                        const licensePlate = option?.licensePlate || "";
                        const name = option?.name || "";
                        const cityText = option?.cityText || "";
                        return `${licensePlate} - ${name} - ${cityText}`.trim();
                      }}
                      filterOptions={(options, { inputValue }) => {
                        return (options || []).filter((option) =>
                          (option?.licensePlate || "")
                            .toLowerCase()
                            .includes(inputValue.toLowerCase()),
                        );
                      }}
                      onChange={(event, newValue) => {
                        if (newValue && typeof newValue !== "string") {
                          setSelectedVehicle(newValue); // keep only selected vehicle
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Search Vehicle"
                          InputLabelProps={{ shrink: true }}
                          autoComplete="off"
                          InputProps={{
                            ...params.InputProps,
                            // Add the loading indicator to the end of the input field
                            endAdornment: (
                              <React.Fragment>
                                {vehicleLoading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />

                    <Box display="flex" gap={2} alignItems="center">
                      <button
                        onClick={() => {
                          setPage(0);
                          setPaginationModel({ page: 0, pageSize: 20 });
                          getAllVehicles();
                        }}
                        className="w-12 h-12 rounded-full bg-violet-500 group shadow-xl flex items-center justify-center relative overflow-hidden"
                      >
                        <svg
                          className="w-6 h-6 text-gray-800 relative z-10 dark:text-white"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeWidth="2"
                            d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                          />
                        </svg>

                        <div className="w-full h-full rotate-45 absolute left-[32%] top-[32%] bg-green-500 group-hover:-left-[100%] group-hover:-top-[100%] duration-1000"></div>
                        <div className="w-full h-full -rotate-45 absolute -left-[32%] -top-[32%] group-hover:left-[100%] group-hover:top-[100%] bg-green-500 duration-1000"></div>
                      </button>

                      <button
                        onClick={() => {
                          handleReset();
                        }}
                        class="cursor-pointer transition-all bg-blue-500 text-white px-4 py-2 rounded-lg
border-blue-600
border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px]
active:border-b-[2px] active:brightness-90 active:translate-y-[2px]"
                      >
                        Reset
                      </button>
                    </Box>
                  </Box>
                </Box>

                <Paper
                  sx={{
                    // width: "80%",
                    boxShadow: 6,
                    borderRadius: 2,
                    mt: 4,
                  }}
                >
                  <Commongrid
                    rows={rows}
                    columns={columns}
                    totalCount={totalCount} // total rows from API
                    handleViewClick={handleViewClick}
                    api={getAllVehicles}
                    setPaginationModel={setPaginationModel}
                    paginationModel={paginationModel}
                    loading={loading}
                    disableColumnMenu={false}
                  />
                </Paper>
              </Box>
            </>
          ) : activeTab === 1 ? (
            <div className="max-w-6xl mx-auto">
              <Textfields
                open={openModal}
                setActiveTab={setActiveTab}
                textfields={vehicleDetailsFields}
                UpdateVehicleDetails={UpdateVehicleDetails}
                form={form}
                handleChange={handleChange}
                setForm={setForm}
                selectedRow={selectedRow}
                error={error}
                editType={editType}
                setError={setError}
                header="Edit Vehicle Details"
                uploadedImages={uploadedImages}
                setUploadedImages={setUploadedImages}
                affectedBookings={() => {}}
                blockedVehciles={() => {}}
              />
            </div>
          ) : (
            <>
              {" "}
              <Textfields
                open={openModal}
                setActiveTab={setActiveTab}
                textfields={vehicleDetailsBlockFields}
                UpdateVehicleDetails={UpdateVehicleDetails}
                form={form}
                handleChange={handleChange}
                setForm={setForm}
                selectedRow={selectedRow}
                error={error}
                editType={editType}
                setError={setError}
                header="Block Vehicle"
                uploadedImages={uploadedImages}
                setUploadedImages={setUploadedImages}
                affectedBookings={affectedBookings}
                blockedVehciles={blockedVehciles}
                setBlockedVehicles={setBlockedVehicles}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default Vehicledashboard;
